// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#CardFooterNext{
    border-radius: 10px 10px 10px 10px !important;
    display: flex;
    /* align-items: center; */
    position: fixed;
    height: -moz-fit-content;
    height: fit-content;
    left:0;
    bottom:0;
    width: 100%;
}
.modalSpinner{
    position: relative  !important;
}

.addInfolist{
    background:"white"; 
    width: "50%";
    display: flex;
    padding-left: 10px;
    justify-content: start;
    align-items: start;
    text-align: start;
}
.addInfolist p{
    margin: 1px;
}
.TotalPriceHeader{
    display: flex !important;
    justify-content: space-between;
    background-color: white !important;
    border-bottom: solid 2px grey;
}
.OrderPrice{
    display: flex;
    justify-content: space-between;
    height: 50px;
    align-content: center;
    align-items: baseline;
    color: gray;
    
}
.ButtonNext{
    color:black;
    background-color: #F4BC16;
    border: none;
}
.footerCard{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.recap{
    padding-left: 10px;
}

.elenco{
    display: flex;
    justify-content: left;
    align-items: left;
    text-align: left;
}

.EliminaBtn{
    background-color: transparent;
    border: none;
    
}
.TitleCardOrder{
Display: flex;
align-items: baseline;
align-content: center;
justify-content: space-between;
}

.ButtonNext:disabled{
    background-color: gray;
}

@media only screen and (max-width: 767px) {
    .footerCard{
        
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
}
    #CardFooterNext{
        border-radius: 10px 10px 0px 0px !important;
        display: flex;
       
        position: fixed;
        left:0;
        z-index: +1;
        bottom:0;
        width: 100%;
        overflow: scroll;
        max-height: 500px;

    }
    .InfoMobile_h{
        display: none;
       }
       .InfoMobile_s{
        margin-top: 10px;
        width: 100%;
    
      }
    
      .desktop{
        width: auto;
  }

}

  @media only screen and (min-width: 768px) and (max-width: 1050px){
    .footerCard{
        
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
}
    .desktop{
        display: none;
    }
    .InfoMobile_h{
        display: none;
       }
       .InfoMobile_s{
        margin-top: 10px;
        width: 100%;
    
      }
    #CardFooterNext{
        border-radius: 10px 10px 0px 0px !important;
        display: flex;
        /* align-items: center; */
        position: fixed;
        z-index: +1;
        left:0;
        bottom:0;
        width: 100%;
        overflow: scroll;
        max-height: 500px;
    }
  }
  @media only screen and (min-width: 1050px) {

    .desktop{
        display: none;
    }
    .InfoMobile_s{
        margin-top: 10px;
        width: 100%;
    
      }
    .InfoMobile_h{
        background-color: blue;
        display: auto !important;
        margin-top: 10px;
        width: 100%;
    
      }
    #CardFooterNext{
        border-radius: 30px !important;
        display: flex;
        width: 20%;
        /* align-items: center; */
        position: fixed;
        z-index: +1;
        left:auto;
        right: 0;
        top:0;
        margin-right: 5%;
        margin-top:10%;
        overflow: scroll;
        max-height: 700px;
        
    }
    #CardFooterNext .card-header{
        display: none;
    }

.ButtonNext{
    color:black;
    background-color: #F4BC16;
    border: none;

    border-radius: 12px;
    width: 150px;
    margin-bottom: 5%;
}
.ButtonNext_ordine{
    color:black;
    background-color: white;
    border: none;
    width: 150px;
    border-radius: 12px;


 
}

#upButton{
    display: none;
}
.recap{
    margin-top: 30%;
}
  }`, "",{"version":3,"sources":["webpack://./src/components/CardFooter_gonext/CardFooter_gonext.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,wBAAmB;IAAnB,mBAAmB;IACnB,MAAM;IACN,QAAQ;IACR,WAAW;AACf;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;;AAEf;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;;AAEhB;AACA;AACA,aAAa;AACb,qBAAqB;AACrB,qBAAqB;AACrB,8BAA8B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;;QAEI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,sBAAsB;QACtB,SAAS;AACjB;IACI;QACI,2CAA2C;QAC3C,aAAa;;QAEb,eAAe;QACf,MAAM;QACN,WAAW;QACX,QAAQ;QACR,WAAW;QACX,gBAAgB;QAChB,iBAAiB;;IAErB;IACA;QACI,aAAa;OACd;OACA;QACC,gBAAgB;QAChB,WAAW;;MAEb;;MAEA;QACE,WAAW;EACjB;;AAEF;;EAEE;IACE;;QAEI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,sBAAsB;QACtB,SAAS;AACjB;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;OACd;OACA;QACC,gBAAgB;QAChB,WAAW;;MAEb;IACF;QACI,2CAA2C;QAC3C,aAAa;QACb,yBAAyB;QACzB,eAAe;QACf,WAAW;QACX,MAAM;QACN,QAAQ;QACR,WAAW;QACX,gBAAgB;QAChB,iBAAiB;IACrB;EACF;EACA;;IAEE;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,WAAW;;MAEb;IACF;QACI,sBAAsB;QACtB,wBAAwB;QACxB,gBAAgB;QAChB,WAAW;;MAEb;IACF;QACI,8BAA8B;QAC9B,aAAa;QACb,UAAU;QACV,yBAAyB;QACzB,eAAe;QACf,WAAW;QACX,SAAS;QACT,QAAQ;QACR,KAAK;QACL,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,iBAAiB;;IAErB;IACA;QACI,aAAa;IACjB;;AAEJ;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;;IAEZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,mBAAmB;;;;AAIvB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;EACE","sourcesContent":["#CardFooterNext{\n    border-radius: 10px 10px 10px 10px !important;\n    display: flex;\n    /* align-items: center; */\n    position: fixed;\n    height: fit-content;\n    left:0;\n    bottom:0;\n    width: 100%;\n}\n.modalSpinner{\n    position: relative  !important;\n}\n\n.addInfolist{\n    background:\"white\"; \n    width: \"50%\";\n    display: flex;\n    padding-left: 10px;\n    justify-content: start;\n    align-items: start;\n    text-align: start;\n}\n.addInfolist p{\n    margin: 1px;\n}\n.TotalPriceHeader{\n    display: flex !important;\n    justify-content: space-between;\n    background-color: white !important;\n    border-bottom: solid 2px grey;\n}\n.OrderPrice{\n    display: flex;\n    justify-content: space-between;\n    height: 50px;\n    align-content: center;\n    align-items: baseline;\n    color: gray;\n    \n}\n.ButtonNext{\n    color:black;\n    background-color: #F4BC16;\n    border: none;\n}\n.footerCard{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.recap{\n    padding-left: 10px;\n}\n\n.elenco{\n    display: flex;\n    justify-content: left;\n    align-items: left;\n    text-align: left;\n}\n\n.EliminaBtn{\n    background-color: transparent;\n    border: none;\n    \n}\n.TitleCardOrder{\nDisplay: flex;\nalign-items: baseline;\nalign-content: center;\njustify-content: space-between;\n}\n\n.ButtonNext:disabled{\n    background-color: gray;\n}\n\n@media only screen and (max-width: 767px) {\n    .footerCard{\n        \n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        gap: 10px;\n}\n    #CardFooterNext{\n        border-radius: 10px 10px 0px 0px !important;\n        display: flex;\n       \n        position: fixed;\n        left:0;\n        z-index: +1;\n        bottom:0;\n        width: 100%;\n        overflow: scroll;\n        max-height: 500px;\n\n    }\n    .InfoMobile_h{\n        display: none;\n       }\n       .InfoMobile_s{\n        margin-top: 10px;\n        width: 100%;\n    \n      }\n    \n      .desktop{\n        width: auto;\n  }\n\n}\n\n  @media only screen and (min-width: 768px) and (max-width: 1050px){\n    .footerCard{\n        \n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        gap: 10px;\n}\n    .desktop{\n        display: none;\n    }\n    .InfoMobile_h{\n        display: none;\n       }\n       .InfoMobile_s{\n        margin-top: 10px;\n        width: 100%;\n    \n      }\n    #CardFooterNext{\n        border-radius: 10px 10px 0px 0px !important;\n        display: flex;\n        /* align-items: center; */\n        position: fixed;\n        z-index: +1;\n        left:0;\n        bottom:0;\n        width: 100%;\n        overflow: scroll;\n        max-height: 500px;\n    }\n  }\n  @media only screen and (min-width: 1050px) {\n\n    .desktop{\n        display: none;\n    }\n    .InfoMobile_s{\n        margin-top: 10px;\n        width: 100%;\n    \n      }\n    .InfoMobile_h{\n        background-color: blue;\n        display: auto !important;\n        margin-top: 10px;\n        width: 100%;\n    \n      }\n    #CardFooterNext{\n        border-radius: 30px !important;\n        display: flex;\n        width: 20%;\n        /* align-items: center; */\n        position: fixed;\n        z-index: +1;\n        left:auto;\n        right: 0;\n        top:0;\n        margin-right: 5%;\n        margin-top:10%;\n        overflow: scroll;\n        max-height: 700px;\n        \n    }\n    #CardFooterNext .card-header{\n        display: none;\n    }\n\n.ButtonNext{\n    color:black;\n    background-color: #F4BC16;\n    border: none;\n\n    border-radius: 12px;\n    width: 150px;\n    margin-bottom: 5%;\n}\n.ButtonNext_ordine{\n    color:black;\n    background-color: white;\n    border: none;\n    width: 150px;\n    border-radius: 12px;\n\n\n \n}\n\n#upButton{\n    display: none;\n}\n.recap{\n    margin-top: 30%;\n}\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
